import "./Form.css";

import React from "react";

const Form = () => {
  return (
    <div className="form-main">
      <form action="https://formspree.io/f/xbjvzvaq" className="form" method="post">
        <h1 className="hed1">Contact us</h1>
        <input type="text" class="input" placeholder="Enter your name" name="Name"/>
        <input type="text" class="input" placeholder="Enter your email" name="Email"/>
        <input type="text" class="input" placeholder="Enter your Phone Number" name="Phone Number" />
        <textarea row="6" class="input" placeholder="Type your Message Her" name="Message" />

        <button>Submit</button>
      </form>
    </div>
  );
};

export default Form;
